import NetworkLineChart, { ChartLine, ChartProps } from './NetworkLineChart'
import { formatTimestamp, getDataDomainByQuery } from '@services/data'
import { useEffect, useMemo, useState } from 'react'

import { formatAsPercentage } from '@utils/numbers'
import { useTranslation } from 'react-i18next'

type SshProcessorChartProps = ChartProps

const SshProcessorChart = (props: SshProcessorChartProps) => {
    const [lines, setLines] = useState<ChartLine[]>([])
    const { t } = useTranslation(['network'])
    const xAxisDomain = useMemo(
        () => getDataDomainByQuery(props.query),
        [props.query]
    )

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            const snapshot = (props.data as any[]).find(
                (d) => d.sshProcessorNumberOfCores
            )

            const numOfLines = +(snapshot?.sshProcessorNumberOfCores || 0)

            setLines([
                ...Array.from({ length: numOfLines }, (_, i) => ({
                    key: `sshProcessorCoreLoad_${i}`,
                    label: `${t('network:data_key_ssh_processor_core')} Cpu ${i}`,
                })),
                {
                    key: 'sshProcessorLoad',
                    label: t('network:data_key_ssh_processor_load'),
                },
            ])
        }
    }, [props.data])

    return (
        <NetworkLineChart
            data={props.data}
            query={props.query}
            setQuery={props.setQuery}
            lines={lines}
            xAxis="timestamp"
            xAxisFormatter={(v) => formatTimestamp(v, props.query)}
            yAxisFormatter={(v) => formatAsPercentage(+v)}
            xAxisDomain={xAxisDomain}
            yAxisDomain={[0, 100]} // Percentage
        />
    )
}
export default SshProcessorChart
